import { useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import { Button, Image } from 'react-bootstrap';
import PaymentServices from 'services/payment';
import { routers } from 'router/router';
import { useHistory } from 'react-router';
interface Props {}

const UpgradeSuccess = (props: Props) => {
    let history = useHistory();
    // const [session, setSession] = useState<any>({}); 
    const location = useLocation();

    const searchParams = new URLSearchParams(window.location.hash.split('?')[1] || location.search);
    const sessionId = searchParams.get('session_id') || '';

    useEffect(() => {   
        async function fetchSession() {
          if (sessionId) {
            try {
              const sessionData = await PaymentServices.checkoutStripSession(sessionId);
              console.log('sessionData:', sessionData);
              sessionStorage.setItem('last_checkout_session',JSON.stringify(sessionData));
            } catch (error) {
              console.error("Error syncing Session from Stripe:", error);
            }
          }
        }
        fetchSession();
      }, [sessionId]);
    

    return (
    <>
    <div className="w-100">
        <div className="row">
        <div className="col-md-12 text-center"> {/* Thêm text-center để căn giữa các phần tử cho đẹp */}

          <div className="PaymentSuccess-iconContainer flex-item width-grow mb-3 mt-5 d-flex justify-content-center" >
            <Image src={'/assets/images/confirm-check.png'} height={'80px'}/>
          </div>

          <h2 className="m-3 mt-4 fw-bold">Your payment has successfully been processed.</h2>

          <div className="m-3">
            <h5 className="text-muted">Please log into your account to refresh your service permissions.</h5>
          </div>

          <Button
              className="w-25 p-3 m-3 mt-4"
              variant="primary"
              onClick={() => history.push(routers.settings.path)}
            >
              <span className="h5 fw-bold">OK</span>
            </Button>
        </div>
        </div>
    </div>
    </>
    );
}

export default UpgradeSuccess;